import { OrderData } from '../models/order.model';

export interface RetryCartLineRef {
  quantity: number;
  productUuid: string;
  parentProductUuid?: string | null;
}

export function retryLinesFromOrderData(
  data: OrderData | null | undefined
): RetryCartLineRef[] {
  if (!data) {
    return [];
  }
  const lineItems = data.lineItems;
  if (Array.isArray(lineItems) && lineItems.length > 0) {
    return lineItems
      .filter((li) => !!li?.productUuid)
      .map((li) => ({
        quantity: li.quantity ?? 1,
        productUuid: li.productUuid,
        parentProductUuid: li.parentProductUuid,
      }));
  }
  const products = data.products;
  if (Array.isArray(products) && products.length > 0) {
    return products
      .filter((p) => !!p?.uuid)
      .map((p) => ({
        quantity: p.quantity ?? 1,
        productUuid: p.uuid,
        parentProductUuid: null,
      }));
  }
  return [];
}

export function buildRetryCartQueryParams(
  lines: RetryCartLineRef[] | null | undefined
): Record<string, string> | null {
  const safeLines = Array.isArray(lines) ? lines : [];
  if (safeLines.length === 0) {
    return null;
  }
  if (safeLines.length === 1) {
    const line = safeLines[0];
    if (!line?.productUuid) {
      return null;
    }
    const parent = line.parentProductUuid?.trim();
    const hasParent = !!parent;
    const product = hasParent ? parent! : line.productUuid;
    const variation = hasParent ? line.productUuid : undefined;
    const q: Record<string, string> = {
      'add-to-cart': '',
      product,
      quantity: String(Math.max(1, line.quantity || 1)),
      'open-cart': 'true',
    };
    if (variation) {
      q['variation'] = variation;
    }
    return q;
  }

  return {
    'add-to-cart': '',
    items: encodeURIComponent(JSON.stringify(safeLines)),
    'open-cart': 'true',
  };
}
